<template>
  <q-dialog :persistent="loading" v-model="sin_ubicacion">
    <q-card style="width: 500px; max-width: 80vw">
      <q-card-section class="row items-center ">
        <div class="text-h6">{{ sectorActual.nombre }}</div>
        <q-space />
        <q-btn :disabled="loading" icon="close" @click="
          mensaje = '';
        reiniciar_cantidad();
        " flat round dense v-close-popup />
      </q-card-section>

      <q-card-section class="q-pt-none flex row">
        <div class="col-12">
          <br />
          <p>Indique la cantidad de entradas</p>
        </div>
        <div class="col-12 col-sm-4  text-center items-center flex-center row">
          <q-btn size="sm" color="accent" icon="remove" :disabled="cantidad_entradas <= 1 || loading"
            @click="cambiar_cantidad(false)" />
          <q-btn :disabled="loading" flat :ripple="false">{{
            cantidad_entradas
            }}</q-btn>
          <q-btn size="sm" :disabled="loading" color="accent" icon="add" @click="cambiar_cantidad(true)" />
        </div>
        <div class="text-h6 text-center col-12 col-sm-4 ">
          {{ store.obtener_pesos(cantidad_entradas * sectorActual.precio) }}
        </div>
        <div class="col-12 q-mt-sm">
          <q-chip v-show="mensaje != ''">
            <q-avatar :icon="errores ? 'close' : 'check'" :color="errores ? 'red' : 'green'" text-color="white" />
            <div class="ellipsis">
              {{ mensaje }}
              <q-tooltip>{{ mensaje }}</q-tooltip>
            </div>
          </q-chip>
        </div>
      </q-card-section>

      <q-card-actions align="right" class="text-teal">
        <!-- <q-btn flat label="Cerrar" v-close-popup /> -->
        <q-btn outline v-if="!loading" @click="anadir_al_carrito()" :disabled="loading" color="primary"
          class="full-width">
          Añadir al carrito
          <q-icon name="add_shopping_cart" />
        </q-btn>
        <q-btn v-else :disabled="loading" color="grey" class="full-width">Añadiendo, aguarde...
          <q-circular-progress indeterminate rounded class="q-ml-md" />
        </q-btn>
        <q-btn v-if="!boton_carrito_desactivado" :flat="boton_carrito_desactivado"
          @click="router.push({ name: 'carrito' })" :disabled="(loading || boton_carrito_desactivado)" color="green"
          class="full-width q-mt-md">
          Ir al carrito
          <q-icon name="shopping_cart_checkout" />
        </q-btn>
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-dialog :persistent="loading" v-model="con_ubicacion">

    <mapa-ubicaciones :sector="seccion"></mapa-ubicaciones>

  </q-dialog>
  <div class="home">
    <q-page class="" v-if="store.evento != null && store.funcion != null">
      <q-pull-to-refresh @refresh="refresh">
        <q-card class="row items-start">
          <div class="col-12 q-mt-sm">
            <q-tabs v-model="tab" dense class="text-grey" active-color="primary" indicator-color="primary"
              align="justify" narrow-indicator>
              <q-tab name="funcion" label="Sectores" icon="confirmation_number" />
              <q-tab name="lugar" label="Lugar" icon="place" />
            </q-tabs>
            <q-separator />
            <q-card-section>
              <q-tab-panels v-model="tab" animated>
                <q-tab-panel name="funcion">
                  <div class="text-h6 q-my-sm">{{ store.evento.evento_nombre }}</div>
                  <p class="q-my-sm">
                    Lugar: <b>{{ funcion.lugar }}</b>
                  </p>
                  <div class="text-orange text-h6 text-weight-bold">
                    {{ funcion.fecha }}
                  </div>
                  <div v-if="!error">
                    <div v-if="loading_sectores">
                      <div class="text-h6 text-center">
                        Cargando sectores, aguarde...
                      </div>
                      <br />
                      <q-skeleton v-for="tmp in [1, 2, 3, 4]" type="rect" class="q-mb-md" :key="tmp" />
                    </div>
                    <div v-else>
                      <div v-if="sectores.length == 0">
                        <div class="text-h6 text-center">
                          No hay sectores disponibles para la venta
                        </div>
                      </div>
                      <div v-else>
                        <div class="text-h6 text-center q-mb-md">
                          Seleccione un sector para continuar
                        </div>
                        <con-mapa :sectores="sectores" :mapa="mapa" v-on:seleccionar_sector_id="seleccionar_sector_id"
                          v-if="tiene_mapa" :url="url"></con-mapa>
                        <sin-mapa :sectores="sectores" v-on:seleccionar_sector="seleccionar_sector"
                          v-if="mostrar_lista_sectores"></sin-mapa>
                        <p v-if="!mostrar_lista_sectores"></p>
                      </div>
                    </div>
                  </div>
                  <div v-else class="justify-center row">
                    <div class="text-h6 text-center col-12 q-a-12">
                      Hubo un error de red, intente nuevamente
                    </div>
                    <br /><br />
                    <q-btn class="primary text-center" @click="obtener_sectores()">Reintentar <q-icon
                        name="refresh" /></q-btn>
                  </div>
                </q-tab-panel>

                <q-tab-panel name="lugar">
                  <div class="text-h6">{{ funcion.lugar }}</div>

                  <iframe width="100%" height="450" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
                    v-if="funcion.latitud != null && funcion.longitud != null"
                    :src="`https://maps.google.com/maps?q=${funcion.latitud},${funcion.longitud}&hl=es;z=14&output=embed`"></iframe>
                </q-tab-panel>
              </q-tab-panels>
            </q-card-section>
          </div>
        </q-card>
      </q-pull-to-refresh>
    </q-page>
  </div>
</template>

<script setup>
// @ is an alias to /src
import { useRouter, } from "vue-router";
import { ref, onMounted, defineProps } from "vue";
import { useEPStore } from "@/store/store";
import SinMapa from "./SinMapa.vue";
import ConMapa from "./ConMapa.vue";
import axios from "axios";
import MapaUbicaciones from "./MapaUbicaciones.vue"
const store = useEPStore();


const props = defineProps(["funcion_id", "evento_slug"]);
const router = useRouter();
const loading_sectores = ref(true);
const funcion = ref(store.funcion);
const evento = ref(store.evento);
const sectores = ref([]);
const error = ref(false);
const tab = ref("funcion");
// const step = ref(1);
const tiene_mapa = ref(false)
const mapa = ref("");
const url = ref("")
const sin_ubicacion = ref(false);
const con_ubicacion = ref(false);
const sectorActual = ref(null);
const cantidad_entradas = ref(1);
const loading = ref(false);
const errores = ref(false);
const mensaje = ref("");
const seccion = ref({})
const boton_carrito_desactivado = ref(true);
const mostrar_lista_sectores = ref(true);
onMounted(() => {
  if (funcion.value == null || store.evento == null) {
    router.push({ name: "evento", params: { evento_slug: props.evento_slug } });
    return;
  }
  obtener_sectores();
});

function obtener_sectores() {
  error.value = false;
  loading_sectores.value = true;
  return axios
    .get(`${store.host}/webapp/listar_sectores?funcion_id=${funcion.value.id}&${store.obtener_credenciales()}`)
    .then(({ data }) => {
      loading_sectores.value = false;
      sectores.value = data.sectores;
      if (data.tiene_mapa) {
        mapa.value = data.mapa;
        // mostrar_lista_sectores.value = (mapa.value.contains('"appCompatible":true'))
      }
      tiene_mapa.value = data.tiene_mapa;
      if (data.url_datos != null) {
        url.value = data.url_datos;
      }
      // error.value=true;
    })
    .catch((e) => {
      // console.log(e);
      error.value = true;
    });
}

function refresh(done) {
  // setTimeout(() => {
  //     done();
  // }, 1000);
  obtener_sectores().then((data) => {
    done();
    // console.log(data);
  });
}

function seleccionar_sector(sector) {
  sectorActual.value = sector;
  if (sector.tiene_ubicacion == true) {
    seccion.value = sector;
    con_ubicacion.value = true;
  } else {
    sin_ubicacion.value = true;

  }
  // emit("seleccionar_sector",sector);
}

function seleccionar_sector_id(sectorId) {
  for (let sector in sectores.value) {
    if (sectores.value[sector]["id"] == sectorId) {
      seleccionar_sector(sectores.value[sector]);
    }
  }
}


function cambiar_cantidad(sumar) {
  if (!sumar) {
    if (cantidad_entradas.value <= 1) return;
    cantidad_entradas.value--;
  } else {
    cantidad_entradas.value++;
  }
}

function anadir_al_carrito() {
  loading.value = true;
  mensaje.value = "";
  errores.value = false;
  axios
    .post(
      `${store.host}/webapp/agregar_entradas`,
      `token=${store.user.token}&user=${store.user.id}&verificar_ubicaciones=false&funcion=${store.funcion.id}&ubicaciones=[{"seccion":"${sectorActual.value.id}","ubicacion":"0","cantidad":"${cantidad_entradas.value}","funcion_id":${store.funcion.id}}]`
    )
    .then(({ data }) => {
      //{"Result":"error","TotalRecordCount":0,"Message":"No se pueden seleccionar esas ubicaciones, ya fueron ocupadas"}
      //{"Result":"ok","TotalRecordCount":0,"Record":{"venta_id":135462,"evento_id":0,"funcion_id":0,"venta_fecha":"2023-06-15","venta_hora":"20:03:43","usuario_id":255,"venta_estado":1,"venta_tipo":"boleteria","entrega_id":0,"transaccion_nps_id":0,"venta_envio_id":0,"venta_fpago":0,"cupon_id":0,"reserva_id":0,"venta_usuario_impresion":0,"venta_fecha_limite":"2023-06-15","venta_hora_limite":"20:18:43","tiempo_extendido":0,"venta_bloqueada":0},"Message":"135462"}

      if (data.Result == "ok") {
        if (cantidad_entradas.value == 1) {
          mensaje.value = `¡${cantidad_entradas.value} entrada añadida exitosamente!`;
        } else {
          mensaje.value = `¡${cantidad_entradas.value} entradas añadidas exitosamente!`;
        }
        store.obtener_carrito();
        boton_carrito_desactivado.value = false;

      } else {
        mensaje.value =
          "Lo sentimos, no hay disponibilidad en el sector seleccionado";
        errores.value = true;
      }
      // console.log(data);
      loading.value = false;
    }).catch((e) => {
      loading.value = false;

      mensaje.value =
        "Ocurrió un error, asegurate de estar conectado a internet";
      errores.value = true;
    });
}

function reiniciar_cantidad() {
  cantidad_entradas.value = 1;
}
</script>
